import { createFileRoute } from "@tanstack/react-router";
import { CROServicePage } from "./services_.cro";

export const Route = createFileRoute("/services_/cro-services")({
  head: () => ({
    meta: [
      {
        title: "CRO Services (Conversion Rate Optimisation) — KMWAdvertising",
      },
      {
        name: "description",
        content: "A/B Testing & Funnel Conversion Rate Optimisation.",
      },
    ],
  }),
  component: CROServicePage,
});
